import React, { useState } from "react";
import styles from "./../Login.module.css";
import axios from "axios";
import { toast } from "react-toastify";
import { apiUrl } from "../../../Constants/Constants";
import { AuthContext } from "../../../Constants/AuthProvider";
const Register = ({
  changeStep,
  loading,
  setLoading,
  referralCode,
  referralPassword,
  setLoginReferral,
}) => {
  const [form, setForm] = useState({
    name: "",
    mobile: "",
    referralCode,
    referralPassword,
  });
  const { onLogin } = React.useContext(AuthContext);
  const changeHandler = (e) => {
    if (e.target.name == "mobile") {
      if (!/^\d*$/.test(e.target.value)) {
        return;
      }
    }
    setForm({
      ...form,
      [e.target.name]: e.target.value,
    });
  };

  const registerUser = async (e) => {
    setLoading(true);
    e.preventDefault();
    if (form.name !== "" && form.mobile !== "") {
      try {
        const response = await axios.post(apiUrl + "referral/register", {
          ...form,
        });

        if (response.data.status === "200") {
          onLogin(response.data?.data?.token, response.data?.data?.name);
        } else {
          switch (response.data?.data?.reason) {
            case "REFERRAL":
              toast.error("حد مجاز ریفرال به پایان رسیده");
              break;
            case "DB_ERR":
              toast.error("خطا در ذخیره سازی اطلاعات");
              break;
            case "EXISTS":
              toast.error("این شماره قبلا در سیستم ثبت شده");
              break;
          }
        }
      } catch (err) {
      } finally {
        setLoading(false);
      }
    }
  };
  return (
    <form className={styles.form} onSubmit={(e) => registerUser(e)}>
      <div className={styles.inputGroup}>
        <input
          type="tel"
          required
          name="mobile"
          placeholder="شماره همراه خود را وارد نمایید"
          className={styles.inputField}
          value={form.mobile}
          onChange={changeHandler}
        />
      </div>
      <div className={styles.inputGroup}>
        <input
          type="text"
          required
          placeholder="نام و نام خانوادگی را وارد نمایید"
          name="name"
          className={`${styles.inputField} ${styles.righter}`}
          value={form.name}
          onChange={changeHandler}
        />
        <div className={styles.desc}>
          <i className="fas fa-exclamation-circle"></i>
          لطفاً نام و نام‌خانوادگی واقعی را وارد کنید. در صورت نیاز، امکان
          ویرایش بعداً وجود دارد.
        </div>
      </div>
      <div className={styles.boxactions}>
        <button type="submit" className={styles.loginButton}>
          عضوم کن
        </button>
        <div
          className={styles.yellowCta}
          onClick={() => setLoginReferral(false)}
        >
          ورود با شماره همراه
        </div>
      </div>
    </form>
  );
};

export default Register;
